import React from 'react';
import { useCountrySelectListQuery } from 'api';
import { Select, SelectProps } from 'components';

export const CountrySelect: React.FC<SelectProps> = React.memo((props) => {
  const { data = [] } = useCountrySelectListQuery();

  return (
    <Select
      options={data}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
